"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationReducer = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _types = require("../types/types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const INITIAL_STATE = {
  connection: null,
  announcements: {
    data: [],
    total_page: 0,
    unread_count: 0,
    total_count: 0
  },
  notifications: {
    all: {
      data: [],
      total_page: 0,
      unread_count: 0,
      total_count: 0
    },
    unread: {
      data: [],
      total_page: 0,
      unread_count: 0,
      total_count: 0
    }
  },
  header: {
    data: [],
    total_page: 0,
    unread_count: 0,
    total_count: 0
  }
};

const notificationReducer = function notificationReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  let action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _types.SET_SOCKET_CONNECTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        connection: action.payload
      });

    case _types.SET_NOTIFICATION_ALL_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: _objectSpread(_objectSpread({}, state.notifications), {}, {
          all: _objectSpread(_objectSpread({}, action.payload), {}, {
            data: [...state.notifications.all.data, ...action.payload.data]
          })
        })
      });

    case _types.SET_NOTIFICATION_UNREAD_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: _objectSpread(_objectSpread({}, state.notifications), {}, {
          unread: _objectSpread(_objectSpread({}, action.payload), {}, {
            data: [...state.notifications.unread.data, ...action.payload.data]
          })
        })
      });

    case _types.SET_NEW_MESSAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: _objectSpread(_objectSpread({}, state.notifications), {}, {
          all: _objectSpread(_objectSpread({}, action.payload), {}, {
            data: [action.payload, ...state.notifications.all.data],
            total_count: state.notifications.all.total_count + 1
          }),
          unread: _objectSpread(_objectSpread({}, state.notifications.unread), {}, {
            data: [action.payload, ...state.notifications.unread.data],
            unread_count: state.notifications.unread.unread_count + 1
          })
        })
      });

    case _types.SET_ANNOUNCEMENT_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        announcements: _objectSpread(_objectSpread({}, action.payload), {}, {
          data: [...state.announcements.data, ...action.payload.data]
        })
      });

    case _types.SET_NEW_ANNOUNCEMENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        announcements: _objectSpread(_objectSpread({}, state.announcements), {}, {
          data: [action.payload, ...state.announcements.data],
          total_count: state.announcements.total_count + 1,
          unread_count: state.announcements.unread_count + 1
        })
      });

    case _types.SET_HEADER_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        header: action.payload
      });

    case _types.SET_NEW_HEADER_MESSAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        header: _objectSpread(_objectSpread({}, state.header), {}, {
          data: [action.payload, ...state.header.data]
        })
      });

    case _types.RESET_NOTIFICATION_ALL_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: _objectSpread(_objectSpread({}, state.notifications), {}, {
          all: _objectSpread(_objectSpread({}, state.notifications.all), {}, {
            data: state.notifications.all.data.filter(_ => _.id != action.payload),
            unread_count: state.notifications.all.unread_count - 1
          })
        })
      });

    case _types.RESET_NOTIFICATION_UNREAD_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: _objectSpread(_objectSpread({}, state.notifications), {}, {
          unread: _objectSpread(_objectSpread({}, state.notifications.unread), {}, {
            data: state.notifications.unread.data.filter(_ => _.id != action.payload),
            unread_count: state.notifications.unread.unread_count - 1
          })
        })
      });

    case _types.SET_MARK_AS_READ:
      {
        const all = state.notifications.all.data.map(_ => {
          if (_.id == action.payload) _.userpreferences.is_read = true;
          return _;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          notifications: _objectSpread(_objectSpread({}, state.notifications), {}, {
            all: _objectSpread(_objectSpread({}, state.notifications.all), {}, {
              data: all,
              unread_count: state.notifications.all.unread_count - 1
            }),
            unread: _objectSpread(_objectSpread({}, state.notifications.unread), {}, {
              data: state.notifications.unread.data.filter(_ => _.id != action.payload),
              unread_count: state.notifications.unread.unread_count - 1
            })
          })
        });
      }

    case _types.SET_REMOVE_NOTIFICATION:
      {
        const all = state.notifications.all.data.filter(_ => _.id != action.payload);
        const isRead = state.notifications.unread.data.findIndex(_ => _.id == action.payload);
        return _objectSpread(_objectSpread({}, state), {}, {
          notifications: _objectSpread(_objectSpread({}, state.notifications), {}, {
            all: _objectSpread(_objectSpread({}, state.notifications.all), {}, {
              data: all,
              unread_count: isRead !== -1 ? state.notifications.all.unread_count - 1 : state.notifications.all.unread_count,
              total_count: state.notifications.all.total_count - 1
            }),
            unread: _objectSpread(_objectSpread({}, state.notifications.unread), {}, {
              data: state.notifications.unread.data.filter(_ => _.id != action.payload),
              unread_count: isRead !== -1 ? state.notifications.unread.unread_count - 1 : state.notifications.unread.unread_count
            })
          })
        });
      }

    default:
      return _objectSpread({}, state);
  }
};

exports.notificationReducer = notificationReducer;